import {registerRoute as workbox_routing_registerRoute} from '/Users/adamt/Repos/common-build/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/Users/adamt/Repos/common-build/node_modules/workbox-strategies/NetworkFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/Users/adamt/Repos/common-build/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/adamt/Repos/common-build/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/adamt/Repos/common-build/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/cdn/certwise-common/js/@dojo/loader/loader.js",
    "revision": "f66a38c73e036053cd0d1f928cb24e38"
  },
  {
    "url": "/cdn/certwise-common/js/core-js/polyfill.js",
    "revision": "149d609e92b0f722f6318e724ee932bd"
  },
  {
    "url": "/cdn/certwise-common/js/main.57a40790cb91dbf0bbad.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-CN_Calendar_mjs.78076cdc33b32205b293.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-TW_Calendar_mjs.bbe176510b5753bb5f82.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-CN_Dialog_mjs.29e6fe1db3effaaba130.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-TW_Dialog_mjs.cd6a73fd363e18768d45.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_fr-CA_DateInput_js.db912f3ec49a111c4412.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-CN_DateInput_js.4d7ac6cfc7717ff635c5.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-TW_DateInput_js.f8e3bc473ee18002f26d.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-CN_index_js.eeeebc0b1d8074dde0a1.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-TW_index_js.4153dec8c58a56ce33aa.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-CN_index_js.706c3102ea6c81c6d6ba.js",
    "revision": null
  },
  {
    "url": "/cdn/certwise-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-TW_index_js.ab7be673dc7e4550a1d8.js",
    "revision": null
  }
], {});




workbox_routing_registerRoute(/.+\/$/, new workbox_strategies_NetworkFirst({ "cacheName":"certwise-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\/js\/sitestart\.js$/, new workbox_strategies_NetworkFirst({ "cacheName":"certwise-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.(?:jpg|jpeg|png|svg|ttf|woff|woff2|eot|ico)$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"certwise-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.css$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"certwise-site", plugins: [] }), 'GET');




